import React from 'react'

import { HiPaperAirplane } from 'react-icons/hi'
import { twMerge } from 'tailwind-merge'

import Spinner from '@/components/common/Spinner'

interface SubmitButton extends React.HTMLProps<HTMLButtonElement> {
  type?: 'submit' | 'button' | 'reset'
  isLoading?: boolean
}

const SubmitButton: React.FC<SubmitButton> = ({
  children,
  disabled,
  isLoading = false,
  ...props
}) => {
  return (
    <button
      {...props}
      type={props.type ?? 'button'}
      disabled={disabled || isLoading}
      className={twMerge(
        'p-1 rounded-[4px] transition-colors duration-100',
        disabled
          ? 'cursor-not-allowed opacity-50 text-primary-500 dark:text-primary-400'
          : 'text-white bg-accent-400 transition-opacity duration-100 hover:opacity-70',
        props.className,
      )}
    >
      {isLoading ? (
        <Spinner className="w-[17px] h-[17px] fill-white dark:fill-white text-accent-500 dark:text-accent-500" />
      ) : (
        <HiPaperAirplane className="rotate-90 w-[17px] h-[17px]" />
      )}
    </button>
  )
}

SubmitButton.displayName = 'RichTextArea.SubmitButton'

export { SubmitButton }
